import { dataLayerPush } from '@libs/analytics';
import type { BazaarvoiceSubmittedData } from '@libs/common-types';
import { BAZAARVOICE_FORM_SELECTOR } from '@app/pdp/constants';

export const submissionSubmitted = ({
    Id,
    contentType,
    SubmittedStep,
}: BazaarvoiceSubmittedData) => {
    // on mandatory review step user leaves a star rating
    if (contentType === 'review' && SubmittedStep === 'mandatory') {
        const el = document.querySelector(BAZAARVOICE_FORM_SELECTOR);
        const selectedStar = el?.shadowRoot?.querySelector(
            '[aria-checked="true"]'
        );
        const rating = parseInt(
            selectedStar?.id?.match(/bv-ips-star-rating-(\d)/)?.[1] ?? '',
            10
        );

        dataLayerPush({
            event: 'post_review',
            product_id: Id,
            rating,
        });
    }
};
